<div class="container-fluid headerdiv">
  <header class="row">
    <div class="col-6 col-sm-6 col-md-4 menu_left">
      <a class="eiplink" href="https://eip4.lntecc.com/" target="_blank"></a>
      <span class="dividerspan"></span>
        <!-- <span class="hptitleContent">{{title}}</span> -->
        <a href="javascript:void(0)" class="modulemenu"  title='Module Menu' (mouseenter)="onHoverTrigger($event)" (click)="onHoverTrigger($event)"></a>
    </div>
    <div class="col-6 col-sm-6 col-md-8 menu_right">

      <div class="profiledropdown container p-0">
        <div class="row m-0">
          <div class="profileinfo col-xs-9 d-none d-md-block">
            <div class="row m-0 text-right"><span class="user_name "
                title={{currentUserName}}>{{ currentUserName }}</span>
            </div>
            <div class="row m-0 text-right"><span
                class="currentdatetime">{{ currentDateTime | date:'dd-MMM-yyyy HH:mm a' }}</span></div>
          </div>
          <div class="profileicon col-xs-3 d-none d-md-block"><span
              class="user_icon">{{ currentUserNameInitial }}</span></div><i class="dropdowntrigger fa"
              [ngClass]="opendropdown?'fa-angle-up': 'fa-angle-down' "
            (click)='Opendropdown()'  id="profiledropdownbtn"></i>
        </div>

        <div class="dropdowncontent no_selection" #profiledropdowndiv *ngIf='opendropdown' id="profiledropdowndiv">
          <div class="user-details text-center my-1">
            <div class="edit-user">
              <div class="row">
                <div class="col-xl-12  col-lg-12 col-md-12 col-sm-12 col-12 "><img alt="User" class="user-img"
                    src="../../edmsui/assets/images/chat-user-icon.png" >
                </div>
                <div class="col-xl-12  col-lg-12 col-md-12 col-sm-12 col-12 mt-1"></div>
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-1 emailtext">
                  <p class="mb-0 font-weight-bold">{{ currentUserEmailId }}</p>
                </div>
                <div class="col-xl-12 col-lg-12 col-md-12 c ol-sm-12 col-12 mt-1">
                  <p class="mb-0">{{ currentUserDesignation }}</p>
                </div>
                <div class="col-xl-12  col-lg-12 col-md-12 col-sm-12 col-12 mt-1">
                  <p class="mb-0" title="DEV Larsen &amp; Toubro Limited, Construction., BFIX Server">
                    {{ currentUserContactNumber }}</p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-12  col-lg-12 col-md-12 col-sm-12 col-12 ">
                <!-- <ul class="list-group text-left"><a href="javascript:void(0);" class="">
                    <li class="list-group-item"><i class="fa fa-change-password"></i>Change Password</li>
                  </a><a href="javascript:void(0);" class="">
                    <li class="list-group-item"><i class="fa fa-delegated-access"></i>Delegated Access</li>
                  </a></ul> -->
                <div class="profile-btn"><a class="loginout-btn btn btn-primary mx-2" href="javascript:void(0);"
                    (click)="onSignOut()">Sign Out</a></div>
              </div>
            </div>
          </div>
        </div>
      </div><span class="dividerspan dividerright float-right d-none d-md-block"></span>
      <div class="notifications-menu-container">
        <span class="notification-icon"><i aria-hidden="true"
              (click)="toggleNotification()" class="fa fa-notifications" id="NotificationiconID"
              style="cursor: pointer;" title="Notifications"></i><span
              class="badge badge-danger notification-badge float-right ">{{notificationsCount}}</span></span>
          <div class="notifications-menu" id="divCol2" *ngIf="showNotification && notificationsCount>0">
            <div class="notifications-header ff-2">
              <p class="mb-0"><span class="ff-3"></span><span class="float-right eip-link " (click)="clearNotifications()">Clear All</span>
              </p>
            </div>
            <div class="notifications-menu-list">
              <div class="notifications-menu-content" id="divCol" *ngFor="let item of pushNotifications">
                <div><span class="nofi-cont float-left ff-2" >{{item.message}}</span></div>
                <div>
                  <p class="mb-0 fs-10 opacity-5 d-inline-block"><i aria-hidden="true" class="fa fa-times-circle fs-10"
                      title="Time">{{item.createdOn | date:'medium'}}</i></p>
                </div>
              </div>
            </div>
            <!-- <div class="notifications-footer eip-link" id="divCol1">
              <p class="text-center eip-link fs-12 mb-0 ">View All</p>
            </div> -->
          </div>
        </div>
      <!-- <span class="dividerspan dividerright float-right d-none d-md-block"></span> -->
      <!-- <span class="breadcrumblinks">
        <i class="fa fa-home" title="Home" style='font-size: 25px; 
        line-height: 28px;
        cursor: pointer;
        color: white;
        padding: 0px 15px;' (click)="navigateToHome()" aria-hidden="true">
        </i>
      </span> -->
      <div class="searchdiv d-none d-lg-block">       
        <!-- <div class="searchselect">
          <kendo-dropdownlist [popupSettings]="{ width: 'auto' }" (valueChange)="searchTypeChange($event)" [data]="listItems" [(ngModel)]="selectedItem"
            textField="text" valueField="value">
          </kendo-dropdownlist>
        </div> -->
        <input #searchInput type="text" class="MenuSearchInput" placeholder="{{placeholder}}" [matAutocomplete]="auto" (keyup.enter)="searchOnChange()" >
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)='autoCompleteChange($event.option.value)' [displayWith]="displayText">
          <mat-option *ngFor="let data of esFilterOutput" [value]="data">
            <span matTooltip="{{data.displayText}}">{{data.displayText}}</span>
          </mat-option>
        </mat-autocomplete>
        <!-- [anchor]="anchor" -->
        <kendo-popup class="Menusearchtreeviewcontainer" >
          <kendo-treeview textField="menuName" class="MenuSearch" [animate]="false">
            <ng-template kendoTreeViewNodeTemplate let-dataItem>
              <span>
                <i [ngClass]="dataItem?.childList?.length === 0 ? 'fa fa-search' : 'fa fa-bars'"></i>
              </span>
            </ng-template>
          </kendo-treeview>
        </kendo-popup>
        <i aria-hidden="true" class="fa fa-search" (click)="searchOnChange()"></i>
      </div>
      <!-- <div class="searchdiv text-white border-0 d-lg-none">
        <i aria-hidden="true" class="fa fa-search"></i>
      </div> -->
    </div>
  </header>
</div>
<div>
  <ul class="breadcrumb">
    <li>
      <span class="breadcrumblinks">
        <i class="fa fa-home cursor-pointer" title="Home" style='font-size: 16px;line-height: 28px;cursor: pointer;' (click)="navigateToHome()"
          aria-hidden="true">
        </i>
      </span>
    </li>
    <!-- <li *ngFor=" let breadcrumb of breadcrumbs">
      <span class="breadcrumblinks">
        <a style="color:#8aa1b5" >
          {{breadcrumb?.parentUrl}}
        </a> 
         <i class="far fa-angle-right" *ngIf="breadcrumb.childurl" style="color:#8aa1b5"></i>    
         <a style="color:white" >
           {{breadcrumb?.childurl}}
         </a>
      </span> 
     </li>     -->
  </ul>
</div>
<div *ngIf="showFloatingIcons" #floatingiconTrigger class="floatingiconTrigger"
  (mouseleave)='showchatpopup=false; openhelpdesk=false;'>
  <div class="fitrigger"><i class="fa fa-chevron-left"></i></div>
  <div class='floatingiconsdiv'>
    <div class='floatingicon fichat'>
      <div id='chatpopupbutton' class="chatlisttrigger" (click)="chatHandler()">
        <span class="filabel" title="Teams Chat">TeamsChat</span>
        <i class="fa fa-comments fiicon" aria-hidden="true"></i>
      </div>
    </div>
    <div class='floatingicon finotes'>
      <span class="filabel" (click)='eipnotesHandler()' title="Notes">Notes</span>
      <i class="fa fa-sticky-note fiicon" aria-hidden="true" (click)='eipnotesHandler()'></i>
    </div>
    <div class='floatingicon ficalculator'>
      <span class="filabel" (click)='calculatorHandler()' title="Calculator">Calculator</span>
      <i class="fa fa-calculator fiicon" aria-hidden="true" (click)='calculatorHandler()'></i>
    </div>
    <!-- <div class='floatingicon ficalculator'>
      <span class="filabel" (click)='eiHelpDocumentHandler()' title="EIP4.0 Tutorials Documents">Tutorials</span>
      <i class="fa fa-duplicate fiicon" aria-hidden="true" (click)='eiHelpDocumentHandler()'></i>
    </div> -->
    <div class='floatingicon fihelpdesk' *ngIf="!!eipUserId && eipUserId>0">
      <a href="{{incidentManagementUrl}}" target="blank">
        <span class="filabel" title="Incident Management">Incident Mgmt</span>
        <i class="fa fa-question-circle fiicon" aria-hidden="true"></i>
      </a>
      <div *ngIf='openhelpdesk' class="helpdeskdiv">
        <div class='helpdeskheader'>Support</div>
        <div class='noDocsAvailable' *ngIf="!HelpdeskDocs">No Documents Available</div>
        <div class="supportItems" *ngFor='let item of HelpdeskDocs'>
          <div class='supportlinkItem' (click)="downloadFile(item)"><i
              class="fa fa-file-o"></i>{{item.AttachmentFileName}}
          </div>
        </div>
      </div>
    </div>
    <div class="floatingicon" *ngIf="!!eipUserId && eipUserId>0">
      <a class="float" (click)="capture()" *ngIf="isHDenable">
        <span class="filabel" title="Take Screenshot">Screenshot</span>
        <i class="fa fa-picture fiicon" title="Screenshot"></i>
      </a>
    </div>
    <div class="floatingicon" *ngIf="!!eipUserId && eipUserId>0">
      <a class="float1" (click)="summaryOpener()" *ngIf="isHDenable">
        <span class="filabel" title="Ticket Creation">Ticket</span>
        <i class="fa fa-plus fiicon"   title="Ticket Creation"></i>
      </a>
    </div>
  </div>
</div>



<div id="quickMenu" class="quick-menu" [ngClass]="{'open': hoverClass === 'open', 'close': hoverClass === 'close'}">
  <nav class="dashboard-hamburger" tabindex="1">
    <ng-template #itemRef let-item="item">
      <a class="line-height-1 quick-menu-item text-decoration-none position-relative d-flex flex-column justify-content-center align-items-center"
        title="{{ item[fileds.name] }}" (click)="navigatePage(item)" [routerLink]="['/', item.menuUrl.split('/')[0], item.menuUrl.split('/')[1]]">
        <i class="fa {{ item[fileds.icon] !== ' ' ? item[fileds.icon] : 'fa-disbursement' }} fs-25 color-11"></i>
        <p class="color-10 eip-pt-5 d-none d-md-block menu-p">{{ item[fileds.name] }}</p>
        <div class="arrow-left"></div>
        <!-- Add the right triangle icon for items with submenus -->
        <i class="fs-15 color-11 arrow-right" *ngIf="item[fileds.subMenu] && item[fileds.subMenu].length > 0">&#10148;</i>
      </a>
    </ng-template>
    <kendo-menu [vertical]="true">
      <kendo-menu-item cssClass="kquick-menu-item" *ngFor="let menuItem of menu">
        <ng-template kendoMenuItemTemplate let-item="item">
          <ng-container *ngTemplateOutlet="itemRef; context: { item: menuItem }">
          </ng-container>
          <kendo-menu-item cssClass="kquick-menu-item kquick-sub-menu" *ngFor="let subItem of menuItem[fileds.subMenu]">
            <ng-template kendoMenuItemTemplate let-item="item">
              <ng-container *ngTemplateOutlet="itemRef; context: { item: subItem }">
              </ng-container>
            </ng-template>
          </kendo-menu-item>
        </ng-template>
      </kendo-menu-item>
    </kendo-menu>
  </nav>
</div>
